import request from 'oc-request';
import { flatObjectSetDataAttributes } from '../dataSetter';

/**
 * Поскольку на странице два дропдуана (один в шапке, второй в меню), нужно проставлять активный элемент.
 */
function setOfficeOptionActive(id) {
	let selectOfficeItemList = document.querySelectorAll(`#selectOffice > .select__item[active]`);
	selectOfficeItemList.forEach(function(selectOfficeItem) {
		selectOfficeItem.removeAttribute('active');
	});
	selectOfficeItemList = document.querySelectorAll(`#selectOffice > .select__item[data-id="${id}"]`);
	selectOfficeItemList.forEach(function(selectOfficeItem) {
		selectOfficeItem.setAttribute('active', '');
	});
}

/**
 * Отправка id офиса для запоминания в сессии.
 */
function setOfficeId() {
	request.sendData('OfficeData::onSetSelected', {
	    data: {
	    	office_id: this.dataset.id,
	    },
	    success: (response) => {
	    	flatObjectSetDataAttributes(response, 'selected-office');
	    	setOfficeOptionActive(response.id);
	    },
	});
}

/**
 * Иницализация: навешивание отслеживания клика по опции селекта.
 */
function init() {
	const selectOfficeItemList = document.querySelectorAll('#selectOffice > .select__item');
	selectOfficeItemList.forEach(function(selectOfficeItem) {
		selectOfficeItem.addEventListener('click', setOfficeId, false);
	});
}

init();
